import { Card, Paragraph } from '@zillow/constellation-10';

const NoToursForDayCard = () => (
  <Card data-testid="ToursSummary-noEventsCard" elevated={false} tone="neutral">
    <Paragraph css={{ textStyle: 'body-sm-bold' }}>No tours for this date</Paragraph>
    <Paragraph textStyle="body-sm">Tours will appear here.</Paragraph>
  </Card>
);

export default NoToursForDayCard;
